import React from 'react';
import LoginMeuCorreios from './login/LoginMeuCorreios';

const Home = () => {
  return (
    <>
      <LoginMeuCorreios />
    </>
  );
};

export default Home;
